import React from "react";
import AdjustRoundedIcon from '@mui/icons-material/AdjustRounded';
import Divider from '@mui/material/Divider';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import Avatar from "../../../../utils/Avatar/Avatar";
import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';
import './route.scss'
import { Button } from "@mui/material";
import NewPlacementVisitModal from "../newVisitModal/newVisitModal";


const RouteCard = (props: any) => {
    return (
        <>
            <div className="flex m-2 pb-2">
                <div className="pb-5 px-1">
                    <AdjustRoundedIcon className="desitiontionaIconColor mx-1" ></AdjustRoundedIcon>
                    <div className="flex h-100 justify-content-center">
                        <Divider orientation="vertical" flexItem className="h-100" />
                    </div>
                </div>
                <div className="px-2">
                    <div className="flex pb-2">
                        <StoreRoundedIcon className="gray-color mx-1" fontSize="small"></StoreRoundedIcon>
                        <p className="body-p mb-0 subTitle">{props.details.placement.CompanyName}</p>
                    </div>
                    <div className="flex pb-2">
                        <FmdGoodRoundedIcon className="gray-color mx-1" fontSize="small"></FmdGoodRoundedIcon>
                        <p className="body-p  mb-0 subTitle">{props.details.placement.RegAddressPostCode}</p>
                    </div>
                    <div className="flex pb-2">
                        <Avatar name={`${props.details.user.first_name} ${props.details.user.last_name}`}></Avatar>
                        <p className="body-p mx-2 mb-0 subTitle">{`${props.details.user.first_name} ${props.details.user.last_name}`}</p>
                    </div>

                </div>
            </div>
        </>

    )

}


const Route = (props: any) => {
    const openGoogleMaps = () => {
        let googleApiUrl = ""
        let wayPointUrl = ""
        props.path.path && props.path.path.map((id: any) => {
            props.placementList.map((elm: any) => {
                if (elm.placement.Id == id && id !== 'UOL') {
                    if (props.placementList.indexOf(elm) === props.placementList.length - 1) {
                        wayPointUrl = wayPointUrl + `${elm.placement.Latitude},${elm.placement.Longitude}`
                    }
                    else {
                        wayPointUrl = wayPointUrl + `${elm.placement.Latitude},${elm.placement.Longitude}%7C`
                    }
                }
            })
        })
    }
    return (
        <div>
            <div className="flex justify-content-between">
                <h1 className="planTripTitle">Your Route Plan</h1>
                <Button onClick={() => {
                    props.planAgain()
                }}>
                   Go Back
                </Button>
            </div>

            <p className="body-p gray-color subTitle">Please find your optimized route plan below.</p>
            <RouteCard details={{
                placement: {
                    CompanyName: "University of Leicester",
                    RegAddressPostCode: "LE1 7RH",
                }, user: {
                    first_name: "University",
                    last_name: "Leicester"
                }
            }}></RouteCard>
            {
                props.path.path && props.path.path.map((id: any) => {
                    if (props.placementList.filter((elm: any) => elm.placement.Id == id && id !== 'UOL').length > 0) {
                        return (
                            <RouteCard details={props.placementList.filter((elm: any) => elm.placement.Id == id && id !== 'UOL')[0]}></RouteCard>
                        )
                    }

                })
            }
            <div className="flex justify-content-between">
                <Button onClick={() => {
                    openGoogleMaps()
                }} variant="contained">
                    Open Google Maps
                </Button>
                {
                    props.path.path && <NewPlacementVisitModal path={props.path} placementList={props.placementList} planAgain={() => {
                        props.planAgain()
                    }} ></NewPlacementVisitModal>
                }
            </div>
        </div>
    )

}
export default Route